import { getGateway } from './../../gateway';

export const getGatewayLogin = state => getGateway(state).login.auth;
export const isUserAuthenticated = state => getGateway(state).login.authenticated;